import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { TableHeaderColumn } from 'react-bootstrap-table';

import { InternalButtonBar } from '../../../layout/components';
import { Button, DataTable } from '../../../../common/components';
import BrokerAssignUser from '../BrokerAssignUser/BrokerAssignUser';
import SelectPrimaryContactModal from '../SelectPrimaryContactModal/SelectPrimaryContactModal';
import BrokerPrimaryContact from '../BrokerPrimaryContact/BrokerPrimaryContact';

import { refreshData } from '../../../../common/components/DataTable/redux/dataTableActions';
import formatDateTime from '../../../../helpers/formatDateTime';

const BrokerUsers = ({
  dispatch,
  brokerId,
  organisation,
  primaryContact,
  brokerName,
}) => {
  const handleRowClick = (row) => {
    dispatch(push('/admin/users/' + row.id));
  };

  const refreshList = () => {
    dispatch(refreshData('users'));
  };

  const getButtons = () => {
    const buttons = [
      {
        permissions: ['user.edit', 'broker.edit'],
        button: (
          <BrokerAssignUser
            className="pull-right"
            brokerId={brokerId}
            callback={refreshList}
          />
        ),
      },
      {
        permissions: ['user.edit', 'broker.edit'],
        button: (
          <Button
            link={true}
            to={{
              pathname: `/admin/users/new/${organisation.data.id}/${brokerId}`,
              query: {
                organisationTypeName:
                  organisation?.data.attributes.organisation_type_name,
              },
              state: {
                organisationName: `${brokerName} Branch`,
              },
            }}
            className="pull-right"
            bsStyle="primary"
            rightIcon="user"
            label="add a new user"
          />
        ),
      },
    ];

    buttons.push({
      permissions: ['user.edit', 'broker.edit'],
      button: (
        <SelectPrimaryContactModal
          bsStyle="primary"
          title={(primaryContact ? 'Change' : 'Add') + ' Primary Contact'}
          brokerId={brokerId}
        />
      ),
    });

    return buttons;
  };

  return (
    <>
      {primaryContact && <BrokerPrimaryContact primaryContact={primaryContact} />}

      <DataTable
        source="/users"
        name="users"
        showTotal
        autoFilter={brokerId}
        autoFilterType="filter[broker]"
        onRowSelect={handleRowClick}
      >
        <TableHeaderColumn dataField="id" isKey hidden />

        <TableHeaderColumn dataField="full_name">Name</TableHeaderColumn>

        <TableHeaderColumn dataField="email" dataSort>
          Email
        </TableHeaderColumn>

        <TableHeaderColumn dataField="status" dataSort width={'180px'}>
          Status
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="created_at"
          dataFormat={formatDateTime}
          width={'180px'}
          dataSort
        >
          Created
        </TableHeaderColumn>
      </DataTable>

      <Row>
        <Col sm={12}>
          <InternalButtonBar buttons={getButtons()} />
        </Col>
      </Row>
    </>
  );
};
BrokerUsers.propTypes = {
  dispatch: PropTypes.func.isRequired,
  brokerId: PropTypes.string.isRequired,
  brokerName: PropTypes.string.isRequired,
  brokerLabel: PropTypes.object.isRequired,
};
export default connect()(BrokerUsers);
